/**
 * @flow
 */

/**
 * Search cleints that match specified query
 * 
 * @param {String} query - The query to search for
 */
export const search = (query: string) => ({
    type: 'CLIENTS.SEARCH',
    query,
});
